import axios from 'axios';
import { IFaqResponse } from 'types/services';
import { Apis } from 'constants/apis';
import { getToken } from 'utils/token';

const getFaqsByType = async (type?: String): Promise<IFaqResponse[]> => {
    const { data } = await axios.get(`${Apis.GET_FAQS}${type ? `${type}`: ''}`, { headers: { Authorization: getToken() } });
    return data;
};

export default getFaqsByType;
